import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener('keydown', (event) => this.trapFocus(event));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener('keydown', (event) => this.trapFocus(event));
  }

  /**
   * @type {object | any}
   */

  #lastActiveElement = null;

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      const payPal = this.querySelector('shopify-paypal-button');
      if (payPal) payPal.tabIndex = 0;
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  /**
   * Closes the dialog when the user clicks outside of it.
   *
   * @param {KeyboardEvent} event - The keybord event.
   *
   */
  trapFocus(event) {
    if (event.code !== 'Tab') return;
    this.#lastActiveElement = event.target;
    if ((this.#lastActiveElement.name === 'PayPal' && !event.shiftKey) || (event.target?.getAttribute('ref') === 'closeButton' && event.shiftKey)) {
      event.preventDefault();
      this.close();
      this.querySelector('[ref="openCartButton"]')?.focus();
    }
    this.#lastActiveElement = event.target;
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
